import { render } from "./address_upload.vue?vue&type=template&id=035986b0&scoped=true"
import script from "./address_upload.vue?vue&type=script&lang=js"
export * from "./address_upload.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035986b0"]])

export default __exports__